// STYLES AND BLOCKS
import "../styles/styles.css";
import "./common.js";

// LIBRARIES
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ANIMATIONS

gsap.registerPlugin(ScrollTrigger);	
gsap.set(".reveal", { autoAlpha: 0, y: 20 });

ScrollTrigger.batch(".reveal", {
    start: "top 85%",
    once: true,
    onEnter: (els) =>
    gsap.to(els, { autoAlpha: 1, y: 0, duration: 0.8, ease: "power2.out", stagger: 0.1 }),
});

document.querySelector('#menu-trigger').addEventListener('click', (ev) => {
    document.querySelector('#nav-main-mobile').classList.add('active');
});

document.querySelector('#nav-main-mobile .close').addEventListener('click', (ev) => {
    document.querySelector('#nav-main-mobile').classList.remove('active');
});

